export default {
  'site.title': 'My Account',
  'duration.unit.month': 'month',
  'duration.unit.month.plural': 'months',
  'duration.unit.year': 'year',
  'duration.unit.year.plural': 'years',
  'licence.unit':'license',
  'licence.unit.plural': 'licenses',
  'extraLicence.unit':'additional license',
  'extraLicence.unit.plural': 'additional licenses',
  'back.dashboard': 'back to dashboard',
  'plan.label': 'Plan',
  'update.subscription.page.plan.label': 'My Plan',
  'update.subscription.page.other.plan.label': 'Other plan',
  'update.subscription.page.other.plan.label.plural': 'Other plans',
  'messagesDialog.wish.dialogTitle': 'Congrats!',
  'messagesDialog.button.goToProduct': 'Go to {productName}',
  'messagesDialog.button.goToSubscription': 'See my subscription',
  'plan.info.trialFeatures.disableLicencesProrationDuringTrial': '{duration} free trial',
  'plan.info.trialFeatures': 'Trial: {licencesCount} free license for {duration}',
  'plan.info.trialFeatures.plural': 'Trial: {licencesCount} free licenses for {duration}',
  'product.drawer.label': 'AODocs product',
  'product.drawer.label.plural': 'AODocs products',
  'product.button.backToProduct': 'Go to {productName}', 
  'product.title.whatIs': 'What is {productName}?',
  'product.plan.title': 'Choose your plan',
  'product.plan.title.plural': 'Choose your plan',
  'product.button.learnMore': 'Learn More',
  'product.button.go': 'Go!',
  'product.switcher.monthly.text': 'MONTHLY',
  'product.switcher.yearly.text': 'YEARLY',
  'product.alreadyExistingSubscription.banner': 'You already have a subscription to this product',
  'plan.base.price': '{licencesCount} users for {price} / {periodicity}',
  'plan.licence.price': '{price}/{periodicity}/{unit}',
  'plan.price': '{basePrice}, then {extraLicencePrice}',
  'plan.button.buyLicences': 'Buy Licenses',
  'plan.button.startFreeTrial': 'Start Free Trial',
  'plan.button.cancel': 'Cancel',
  'plan.button.purchase': 'Purchase',
  'plan.button.tryIt': 'Try it',
  'plan.button.subscribe': 'Subscribe',
  'plan.button.choose': 'Choose',
  'plan.update.button': 'update plan',
  'plan.greeting.title': 'Thank you for starting a trial for {productName} {planName}!',
  'plan.greeting.content': 'To be sure you can continue to use the product at the end of the trial, we invite you to fill in your payment information.',
  'plan.greeting.yes.button': 'Add payment info',
  'plan.greeting.no.button': 'See my subscription',
  'subscription.button.manageSubscription': 'Manage subscription',
  'subscription.button.getStarted': 'Get Started',
  'subscription.info.inviteToUse': "You've been invited to join this account.",
  'subscription.banner.info.inviteToUse': "You've been invited to join {ownerEmail}'s {productName} subscription, note that you can be linked to only one subscription.",
  'subscription.banner.info.inviteToUse.domainRegistered.license': 'You have been invited by {ownerEmail}  to join the {domainName} domain subscription to use one {productName} license. Note that you can join only one subscription',
  'subscription.warning.noPaymentInfo': 'You have not entered a payment method',
  'subscription.warning.noLicence': "You don't have a license",
  'subscription.button.grantMeALicence': 'Grant me a license',
  'invitation.linked.banner': ' You are linked to {owner}\'s subscription',
  'invitation.button.denyInvitation': 'Decline',
  'invitation.confirmation.denyInvitation': 'Are you sure you want to decline this invitation?',
  'invitation.button.acceptInvitation': 'Accept',
  'invitation.confirmation.title': 'Confirm Account',
  'invitation.confirmation.acceptInvitationWarning': 'Important: You can only be associated with one account. If you already have a license for this product, your data will now be associated with the account of {ownerEmail}.',
  'invitation.confirmation.acceptInvitation': 'Please confirm that you want to accept this invitation.',
  'invitation.confirmation.yes': 'Confirm',
  'invitation.confirmation.no': 'Cancel',
  
  'resource.label.shared_folders': 'Shared Folders',
  'resource.label.shared_guests': 'Shared Guests',
  'resource.label.shared_bytes': 'Monthly traffic',
  'resource.label.licence': 'License',
  'resource.unit.folder.plural': 'folders',
  'resource.unit.folder': 'folder',
  'resource.unit.user.plural': 'Guests',
  'resource.unit.user': 'Guest',
  'resource.unit.bytes.plural': 'bytes',
  'resource.unit.bytes': 'byte',
  'resource.unit.megabytes.plural': 'MB',
  'resource.unit.megabytes': 'MB',
  'resource.unit.gigabytes.plural': 'GB',
  'resource.unit.gigabytes': 'GB',
  'resource.unit.licence.plural': 'licenses',
  'resource.unit.licence': 'license',
  'domain.plan.label.title': 'Domain',
  'domain.plan.label.description': 'domain to register',
  'domain.plan.label.description.plural': 'domains to register',
  'subscription.label': 'Subscription',
  'subscription.drawer.label': 'My Subscription',
  'subscription.drawer.label.plural': 'My Subscriptions',
  'subscription.messages.created': "Subscribed!",
  'subscription.messages.cancelled':"You've successfully canceled your subscription",
  'subscription.messages.reactivated':"You've successfully reactivated your subscription",
  'subscription.messages.updated':"You've successfully updated your subscription",
  'subscription.messages.paymentInfoUpdated':"You've successfully updated your payment information",
  'subscription.messages.paymentInfoUpdated.withTrialing':"You’ve successfully entered your payment info.\n\nYou are in your trial period. Billing will start when your trial period ends.",
  'subscription.page.title': 'My Subscription',
  'subscription.notFound': "Subscription Not Found",
  'subscription.page.titleWithProduct': 'My {productName} Subscription',
  'subscription.change.button.reset': 'Reset',
  'subscription.change.button.cancel': 'Cancel',
  'subscription.change.button.updateSubscription': 'Update Subscription',
  'subscription.button.changeSubscription': 'Change Subscription',
  'subscription.invitations.tab.label': 'Invitations',
  'subscription.users.tab.label': 'Users',
  'subscription.domains.tab.label': 'Domains',
  'subscription.resourceUsage.label': 'Resources usage',
  'subscription.invitations.invite.button.cancel': 'Cancel',
  'subscription.invitations.invite.button.sendInvites': 'Send invites',
  'subscription.invitations.button.inviteUsers': 'Invite users',
  'subscription.invitations.info.invitesSent': 'Invitations Sent!',
  'subscription.invitations.info.noInvitesSent': 'No invitations were sent: provided emails were either previously invited, or already use this subscription.',
  'subscription.invitations.info.noInvitation': 'No Pending Invitations',
  'subscription.invitations.button.cancelInvitation': 'Cancel Invitation',
  'subscription.invitations.confirmation.cancelInvitation': 'Are you sure that you want to cancel this invitation?',
  'subscription.invitations.confirmation.cancelInvitation.title': 'Cancel invitation',
  'subscription.invitations.column.email': 'Email',
  'subscription.invitations.update.text.updateSubscription': "You don't have any licenses available in your current subscription. To invite users, update your subscription.",
  'subscription.invitations.update.button.updateSubscription': 'Update Subscription',
  'subscription.users.info.noUser': 'No Users',
  'subscription.users.column.name': 'Name',
  'subscription.users.column.email': 'Email',
  'subscription.users.column.host': 'Host',
  'subscription.users.column.quotaUsage': 'Usage',
  'subscription.users.button.removeUser': 'Remove user',
  'subscription.users.confirmation.removeUser': 'Are you sure that you want to remove this user?',
  'subscription.users.confirmation.removeUser.title': 'Remove a user',
  'user.admin.switchOn.tooltip.text': "Switch ON to activate your license and have user access to the product",
  'user.admin.switchOff.tooltip.text': "Switch OFF to deactivate your license if you don't want to use the product",
  'user.admin.status.indicator.text': 'Admin',
  'subscription.domains.register.button.registerDomain': 'Register domain',
  'subscription.domains.register.message.general': 'By registering a domain, any user on your domain who accesses {productName} will join the subscription without invitation and consume one license. If necessary, update your subscription to add more licenses. When there are no more licenses available, users on your domain won’t be able to join this subscription.',
  'subscription.domains.register.message.already': 'The {domain} domain is already registered by another user. If you think this is a mistake, contact our support ', 
  'subscription.domains.update.button.updateSubscription': 'Update Subscription',
  'subscription.domains.update.button.contactUs': 'Contact us',
  'subscription.domains.update.text.updateSubscription': 'You can’t add a domain because you don’t have the domain registration option in your current subscription plan. To register a domain, update your subscription.',
  'subscription.domains.confirmation.registerDomain.title': 'Confirm domain registration?', 
  'subscription.domains.confirmation.registerDomain.button.cancel': 'Cancel', 
  'subscription.domains.confirmation.registerDomain.button.confirm': 'Confirm', 
  'subscription.domains.confirmation.registerDomain.description': 'The {domain} domain will be registered for your subscription. All users on {domain} who access the product will be auto-allocated to your subscription.', 
  'subscription.domains.confirmation.registerDomain.descriptionSecond': 'A domain can be registered only once for a product, so other users won’t be able to register {domain} for their subscription.',
  'subscription.domains.confirmation.removeDomain.title': 'Remove {domainName} domain?',
  'subscription.domains.confirmation.removeDomain.description': ' The {domainName} domain will no longer be registered. You’ll have to manually invite new users on this domain. Users on this domain already in your subscription won’t be affected. They’ll stay in your subscription. ',
  'subscription.domains.confirmation.removeDomain.button.cancel': 'Cancel', 
  'subscription.domains.confirmation.removeDomain.button.confirm': 'Remove',
  'subscription.domains.column.domainName': 'Domain name',
  'subscription.domains.column.licencesNumber': 'Total number of licence(s)',
  'subscription.domains.snack.success.domainRegistered':  'Your {value} domain has been successfully registered',
  'subscription.domains.snack.error.inviting.error': ' Error when trying to register your {value} domain. Try again or contact our support.',
  'subscription.domains.snack.success.domainRemoved': 'The {value} domain has been successfully removed from your subscription.',
  'subscription.domains.snack.error.removing.error': 'Error when trying to remove the {value} domain. Try again or contact our support.',
  'subscription.domains.domainRegistered': 'Your domain has been successfully registered',
  'subscription.domains.domainRemoved': 'Your domain has been successfully removed',
  'subscription.card.domainUsage.label': 'Domain',
  'subscription.card.domainUsage.unit': 'Registered domain',
  'subscription.card.domainUsage.unit.plural': 'Registered domains',

  'subscription.form.plan.label': 'Plan',
  'subscription.form.licencesCount.label': 'Number of Licenses',
  'subscription.form.licencesCount.helper': '{licencesCount} minimum',
  'subscription.form.subtotal.label': 'Total price',
  'subscription.button.resume': 'Reactivate subscription',
  'subscription.button.pause': 'Cancel subscription',
  'subscription.confirmation.pause': 'Are you sure that you want to cancel your {product} subscription?',
  'subscription.confirmation.pause.title': 'Cancel subscription',
  'subscription.confirmation.resume': 'Are you sure that you want to reactivate your {product} subscription?',
  'subscription.confirmation.resume.title': 'Reactivate your subscription',
  'subscription.confirmation.chargify.redirection': "You'll be redirected to the Payment Info form. Confirm to proceed!",
  'subscription.confirmation.plan.update': 'Are you sure that you want to change your plan?',
  'subscription.confirmation.plan.update.info': 'You may be charged',
  'subscription.confirmation.plan.update.title': 'Change your plan',
  'subscription.confirmation.update.plan': 'Are you sure that you want to update your plan?',
  'subscription.confirmation.update.plan.title': 'Plan update',
  'subscription.confirmation.endOfTrial.info': 'Are you sure you want to switch to a {planName} plan now?\nYour trial period on {subscriptionPlanName} will be ended.',
  'subscription.info.updatedLicences.notAllowedPlanSwitch.title': 'Too many licences used',
  'subscription.info.updatedLicences.notAllowedPlanSwitch': 'You have too many licenses allocated, {planName} plan allows only one license.', 
  'subscription.domain.info.updatedLicences.notAllowedPlanSwitch.title': 'Too many domains registered',
  'subscription.domain.info.updatedLicences.notAllowedPlanSwitch': "You have too many domains, {planName} plan doesn't allows domain registration.", 
  'subscription.button.setPaymentInfo': 'Add Payment Info',
  'subscription.button.updatePaymentInfo': 'Update payment info',
  'subscription.status.label': 'Status',
  'subscription.trialExpirationDate.label': 'Expiration date',
  'subscription.currentPeriodEndDate.label': 'Subscription Renewal Date',
  'subscription.price': '{price} / {periodicity}',
  'subscription.price.unknown': 'N/A',
  'subscription.payment.proceeding':'Processing Payment Info',
  'subscription.payment.proceeding.error':'There was an error when processing your payment info',
  'subscription.owner.label': 'Owner',
  'subscription.status.trialing': 'Trialing',
  'subscription.status.trial_ended': 'Trial ended',
  'subscription.status.active': 'Active',
  'subscription.status.soft_failure': 'Soft failure',
  'subscription.status.past_due': 'Past due',
  'subscription.status.canceled': 'Canceled',
  'subscription.status.unpaid': 'Unpaid',
  'subscription.status.expired': 'Expired',
  'subscription.status.on_hold': 'On hold',
  'subscription.status.assessing': 'Assessing',
  'subscription.status.pending': 'Pending',
  'subscription.status.failed_to_create': 'Failed to create',
  'subscription.greeting.title.default': 'Thank you for starting your free trial of {planName}!',
  'subscription.greeting.title.withoutTrial': 'Thank you for your subscription to {planName}!',
  'subscription.greeting.content.default': 'Manage your {productName} trial or subscription from My Account',
  'subscription.greeting.content.withoutTrial': 'Manage your {productName} subscription from My Account',
  'subscription.greeting.getStarted.button': 'Go to AOBox',
  'subscription.greeting.myAccount.button': 'See my subscription',
  'subscription.warning.max.licences.reached': 'You don’t have any more licenses available for this product. New users on your {domain} domain who want to use the product won’t be able to join your subscription',
  'subscription.warning.link': 'ADD MORE LICENSES',
  'invitation.label': 'Invitation',
  'invitation.notFound':"Invitation doesn't exist or has expired.",
  'invitation.subscription.info': "You've been invited to join this account",
  'licence.label': 'License',
  'licence.label.plural': 'Licenses',
  'licence.add.button': 'add licences',
  'licence.revoke.button': 'Revoke',
  'licence.revoke.confirmation': 'Are you sure you want to revoke this license?',
  'licence.existingLicence.banner': "You are linked to {ownerEmail}'s subscription",
  'subscription.creationDate.label': 'Start Date',
  'pagination.labelRowsPerPage': 'Rows per page:',
  'pagination.labelDisplayedRows': '{from}-{to} of {count}',
  'account.creating.dialog.title': 'Create Your Account',
  'account.creating.dialog.content': 'Please wait while your account is being created',
  'errors.dialog.ok.button': 'OK',
  'footer.copyright': ' © {year}',
  'error.page.backToYourAccount.button': 'Back to your account',
  'header.logout.button': 'Log out',
  'header.faq.button': 'FAQ',
  'error.dialogTitle': 'Error!',
  'error.snacks.apiError': 'Error',
  'confirm.dialogTitle': 'Confirm',
  'confirm.dialog.yes.button': 'Yes',
  'confirm.dialog.no.button': 'No',
  'confirm.dialog.default.message': 'Are you sure?',
  'deny.dialogTitle': 'Info',
  'deny.dialog.close.button': 'Close',
  'deny.dialog.default.message': "You can't perform this action",
  'button.ok': 'OK',
  'billingInfo.button.confirm': 'Confirm',
  'alert.banner.message': 'Welcome to the new Interface, you are at the right place to manage your subscription',

  'error.reasons.insufficientInvitationQuota': 'Insufficient number of licences\n\nNo invitations have been sent',
}


// WEBPACK FOOTER //
// ./src/constants/translations.en.js